import type { EvaluationResult } from '@ts-assessment/interfaces'

import { EvaluationResultId } from '@ts-assessment/enums'

const configEvaluationResultImprove: EvaluationResult = {
  id: EvaluationResultId.OpportunitiesToImprove,
  title: 'You are here',
  emoji: '💪',
  score: 'Opportunities to Improve',
  detail: 'Currently does not meet the expected proficiency level in core English Language Arts strands and may require additional support.',
  subtitle: 'Below 50%',
  color: 'red',
}

const configEvaluationResultOnTrack: EvaluationResult = {
  id: EvaluationResultId.OnTrack,
  title: 'You are here',
  emoji: '👌',
  score: 'On Track',
  detail: 'Proficiency level in core English Language Arts strands is on par with other learners in the same grade.',
  subtitle: '50-80%',
  color: 'amber',
}

const configEvaluationResultExcelling: EvaluationResult = {
  id: EvaluationResultId.Excelling,
  title: 'You are here',
  emoji: '👍',
  score: 'Excelling',
  detail: 'Above the proficiency level expectations in core English Language Arts strands.',
  subtitle: 'Above 80%',
  color: 'emerald',
}

const configResultCheckUpExcelling: EvaluationResult = {
  id: EvaluationResultId.Excelling,
  title: 'You are here',
  emoji: '👍',
  score: 'Excelling',
  detail: 'Above the proficiency level expectations in core Comprehension strands',
  subtitle: 'Above 80%',
  color: 'emerald',
}

const configResultCheckUpOnTrack: EvaluationResult = {
  id: EvaluationResultId.OnTrack,
  title: 'You are here',
  emoji: '👌',
  score: 'On Track',
  detail: 'Proficiency level in core Comprehension strands is on par with other learners in the same grade',
  subtitle: '50-80%',
  color: 'amber',
}

const configResultCheckUpImprove: EvaluationResult = {
  id: EvaluationResultId.OpportunitiesToImprove,
  title: 'You are here',
  emoji: '💪',
  score: 'Area for improvement',
  detail: 'Currently does not meet the expected proficiency level in core Comprehension strands and may require additional support',
  subtitle: 'Below 50%',
  color: 'red',
}

export const configElaEvaluationResults: EvaluationResult[] = [
  configEvaluationResultImprove,
  configEvaluationResultOnTrack,
  configEvaluationResultExcelling,
]

export const configCheckUpElaEvaluationResults: EvaluationResult[] = [
  configResultCheckUpExcelling,
  configResultCheckUpOnTrack,
  configResultCheckUpImprove,
]
